function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  stroke: "#2B9D8B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  transform: "translate(-127.000000, -742.000000) translate(0.000000, 726.000000) translate(95.000000, 0.000000) translate(32.000000, 16.000000) translate(1.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2B9D8B",
  d: "M16 18v-2c0-2.21-1.79-4-4-4H4c-2.21 0-4 1.79-4 4v2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 4,
  r: 4,
  fill: "#2B9D8B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 18v-2c-.001-1.823-1.235-3.414-3-3.87M15 .13c1.77.453 3.008 2.048 3.008 3.875S16.77 7.427 15 7.88"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z",
  transform: "translate(-127.000000, -742.000000) translate(0.000000, 726.000000) translate(95.000000, 0.000000) translate(32.000000, 16.000000)"
}))))));

function SvgPatientsActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientsActive);
export default __webpack_public_path__ + "static/media/patients_active.7515d9b8.svg";
export { ForwardRef as ReactComponent };